export default __webpack_public_path__ + "static/media/hero-text-left.40ae2fb8.png";